import { useApiQuery } from "app/modules/api-client";
import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import type { IIndustryDataAvailabilityState } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";
import { INDUSTRY_ENDPOINT_MIN_DATE } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";

import { useIndustryAvailabilityParams } from "../useIndustryAvailabilityParams";

interface IIndustryDeviceBreakdownData {
    spendShare: number;
    impressionsShare: number;
    visitsShare: number;
    startDate: string;
}

interface IUseIndustryDeviceBreakdownResult {
    data?: IIndustryDeviceBreakdownData;
    isLoading: boolean;
    isError: boolean;
    availability: IIndustryDataAvailabilityState;
}

export const useIndustryDeviceBreakdown = (category: IFlattenedCategory): IUseIndustryDeviceBreakdownResult => {
    const { params, availability } = useIndustryAvailabilityParams(
        category,
        INDUSTRY_ENDPOINT_MIN_DATE.adintelligenceIndustryDeviceList,
    );

    const { data, isLoading, isFetching, isError } = useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName: "adintelligenceIndustryDeviceList",
            options: {
                enabled: !availability.isFullyUnavailable,
                select: (response) => ({
                    spendShare: response?.spendDesktopShare,
                    impressionsShare: response?.impressionsDesktopShare,
                    visitsShare: response?.visitsDesktopShare,
                    startDate: response?.startDate,
                }),
            },
        },
        params,
    );

    return {
        data,
        isLoading: isLoading || isFetching,
        isError,
        availability,
    };
};
